(function () {
  'use strict';

  var GAP = 16;
  var AUTOPLAY_MS = 7000;
  var TRANSITION_MS = 900;

  function getVisible() {
    var w = window.innerWidth;
    if (w >= 990) return 3;
    if (w >= 640) return 2;
    return 1;
  }

  function BSGCarousel(section) {
    this.section = section;
    this.track = section.querySelector('.bsg-rv__track');
    this.viewport = section.querySelector('.bsg-rv__viewport');
    this.prevBtn = section.querySelector('.bsg-rv__arrow--prev');
    this.nextBtn = section.querySelector('.bsg-rv__arrow--next');
    this.dotsWrap = section.querySelector('.bsg-rv__dots');
    if (!this.track) return;
    this.originals = Array.from(this.track.children);
    this.total = this.originals.length;
    if (this.total === 0) return;
    this.visible = Math.min(getVisible(), this.total);
    this.current = Math.floor(Math.random() * this.total);
    this.position = 0;
    this.animating = false;
    this.timer = null;
    this._resizeHandler = null;
    this._buildClones();
    this._buildDots();
    this._go(this.current, false);
    this._startAutoplay();
    this._bindEvents();
    this._observeIn();
  }

  BSGCarousel.prototype._buildClones = function () {
    this.track.querySelectorAll('.bsg-rv__card--clone').forEach(function (c) { c.remove(); });
    var v = this.visible, total = this.total, originals = this.originals, track = this.track;
    var frag = document.createDocumentFragment();
    for (var i = total - v; i < total; i++) {
      var cl = originals[i].cloneNode(true);
      cl.classList.add('bsg-rv__card--clone');
      cl.setAttribute('aria-hidden', 'true');
      frag.appendChild(cl);
    }
    track.insertBefore(frag, track.firstChild);
    for (var j = 0; j < v; j++) {
      var cl2 = originals[j].cloneNode(true);
      cl2.classList.add('bsg-rv__card--clone');
      cl2.setAttribute('aria-hidden', 'true');
      track.appendChild(cl2);
    }
    this.allCards = Array.from(this.track.children);
  };

  BSGCarousel.prototype._buildDots = function () {
    this.dotsWrap.innerHTML = '';
    var self = this;
    for (var i = 0; i < this.total; i++) {
      (function (idx) {
        var dot = document.createElement('button');
        dot.className = 'bsg-rv__dot';
        dot.setAttribute('role', 'tab');
        dot.setAttribute('aria-label', 'Review ' + (idx + 1) + ' of ' + self.total);
        dot.addEventListener('click', function () { self._go(idx, true); self._resetAutoplay(); });
        self.dotsWrap.appendChild(dot);
      })(i);
    }
    this.dots = Array.from(this.dotsWrap.children);
  };

  BSGCarousel.prototype._cardWidth = function () {
    var vw = this.viewport.offsetWidth;
    return (vw - GAP * (this.visible - 1)) / this.visible;
  };

  BSGCarousel.prototype._setTrack = function (animate) {
    var w = this._cardWidth();
    if (w <= 0) return;
    this.allCards.forEach(function (c) { c.style.width = w + 'px'; });
    var offset = -(this.position * (w + GAP));
    this.track.style.transition = animate
      ? 'transform ' + TRANSITION_MS + 'ms cubic-bezier(0.25,0.46,0.45,0.94)'
      : 'none';
    this.track.style.transform = 'translateX(' + offset + 'px)';
  };

  BSGCarousel.prototype._updateDots = function () {
    var cur = this.current;
    this.dots.forEach(function (d, i) {
      var on = i === cur;
      d.classList.toggle('bsg-rv__dot--active', on);
      d.setAttribute('aria-selected', on ? 'true' : 'false');
    });
  };

  BSGCarousel.prototype._go = function (index, animate) {
    this.current = ((index % this.total) + this.total) % this.total;
    this.position = this.visible + this.current;
    this._setTrack(animate);
    this._updateDots();
  };

  BSGCarousel.prototype.next = function () {
    if (this.animating) return;
    this.animating = true;
    this.current = (this.current + 1) % this.total;
    this.position++;
    this._setTrack(true);
    this._updateDots();
  };

  BSGCarousel.prototype.prev = function () {
    if (this.animating) return;
    this.animating = true;
    this.current = (this.current - 1 + this.total) % this.total;
    this.position--;
    this._setTrack(true);
    this._updateDots();
  };

  BSGCarousel.prototype._onTransEnd = function (e) {
    if (e.propertyName !== 'transform') return;
    this.animating = false;
    var v = this.visible, total = this.total;
    if (this.position >= v + total) { this.position = v; this._setTrack(false); }
    else if (this.position < v) { this.position = v + total - 1; this._setTrack(false); }
  };

  BSGCarousel.prototype._startAutoplay = function () {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var self = this;
    this._stopAutoplay();
    this.timer = setInterval(function () { self.next(); }, AUTOPLAY_MS);
  };

  BSGCarousel.prototype._stopAutoplay = function () { clearInterval(this.timer); };
  BSGCarousel.prototype._resetAutoplay = function () { this._stopAutoplay(); this._startAutoplay(); };

  BSGCarousel.prototype.destroy = function () {
    this._stopAutoplay();
    if (this._resizeHandler) window.removeEventListener('resize', this._resizeHandler);
  };

  BSGCarousel.prototype._bindEvents = function () {
    var self = this;
    this.track.addEventListener('transitionend', function (e) { self._onTransEnd(e); });
    this.prevBtn.addEventListener('click', function () { self.prev(); self._resetAutoplay(); });
    this.nextBtn.addEventListener('click', function () { self.next(); self._resetAutoplay(); });
    this.section.addEventListener('mouseenter', function () { self._stopAutoplay(); });
    this.section.addEventListener('mouseleave', function () { self._startAutoplay(); });

    var startX = 0;
    this.viewport.addEventListener('touchstart', function (e) {
      startX = e.touches[0].clientX;
    }, { passive: true });
    this.viewport.addEventListener('touchend', function (e) {
      var diff = startX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 45) {
        if (diff > 0) self.next(); else self.prev();
        self._resetAutoplay();
      }
    }, { passive: true });

    this.section.setAttribute('tabindex', '-1');
    this.section.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { self.prev(); self._resetAutoplay(); }
      if (e.key === 'ArrowRight') { self.next(); self._resetAutoplay(); }
    });

    var resizeTimer;
    this._resizeHandler = function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        if (!self.section.isConnected) { self.destroy(); return; }
        var newV = Math.min(getVisible(), self.total);
        if (newV !== self.visible) {
          self.visible = newV;
          self._buildClones();
          self._buildDots();
        }
        self._go(self.current, false);
      }, 160);
    };
    window.addEventListener('resize', this._resizeHandler);
  };

  BSGCarousel.prototype._observeIn = function () {
    var self = this;
    var section = this.section;
    var show = function () {
      section.classList.add('bsg-rv--visible');
      // Re-measure card widths now that section is visible
      self._go(self.current, false);
    };
    var fallback = setTimeout(show, 300);
    if (!('IntersectionObserver' in window)) { clearTimeout(fallback); show(); return; }
    var obs = new IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting) { clearTimeout(fallback); show(); obs.disconnect(); }
    }, { threshold: 0 });
    obs.observe(section);
  };

  function initCarousels(context) {
    var scope = context || document;
    // Destroy stale instances whose DOM has been replaced
    scope.querySelectorAll('[data-bsg-reviews]').forEach(function (el) {
      if (el.bsgRvInstance && !el.bsgRvInstance.section.isConnected) {
        el.bsgRvInstance.destroy();
        delete el.bsgRvInstance;
        el.bsgRvDone = false;
      }
      if (!el.bsgRvDone) {
        el.bsgRvDone = true;
        el.bsgRvInstance = new BSGCarousel(el);
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () { initCarousels(); });
  document.addEventListener('shopify:section:load', function (e) { initCarousels(e.target); });
})();
